import { formatUrlSuffix, get } from '@libs/shared';

/**
 * 获取带base_path的路由路径
 *
 * @param router
 */
export const getBasePathRouter = (router: string) => {
    return formatUrlSuffix(get(window.jdy_config, 'base_path', ''), router);
};
